module.exports = __webpack_public_path__ + "static/media/05ilustracion.11c9adab.png";